/**
 * Empty in dev so requests are same-origin and hit the Vite proxy; set to the deployed
 * API's absolute URL at build time in production, where the SPA and the API are separate
 * Dokploy services on different hostnames.
 */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? '').replace(/\/$/, '');

/** Where the session WebSocket connects. Same origin as the API in both environments. */
export function apiOrigin(): string {
  return API_BASE_URL || globalThis.location.origin;
}

export const SESSION_STORAGE_KEY = 'proctoring.web.session';

/**
 * Where a blocked candidate is told to write.
 *
 * This is the escape hatch on every failure branch of the download panel — a manifest that
 * will not load, a release with no installer for their platform, an install that will not
 * start. It shipped as `support@proctoring.example.com`, an IANA-reserved domain that cannot
 * receive mail, so the one instruction given to a stuck candidate bounced. Configurable so a
 * deployment points it at an inbox someone actually reads.
 */
export const SUPPORT_EMAIL = import.meta.env.VITE_SUPPORT_EMAIL ?? 'support@aimamin.com';
